import styled from 'styled-components';

import { $dmSansFontFamily, colorsPalettes } from '@similarweb/styles';

export const StyledExpandableText = styled.div`
  color: ${colorsPalettes.carbon[400]};
  font-family: ${$dmSansFontFamily};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 12px 0;
`;

export const StyledAgentsWrapper = styled.div`
  display: flex;
  flex: 1;
  gap: 8px;

  > * {
    flex: 1;
  }
`;
